import { SupabaseClient, createClient } from "@supabase/supabase-js";
import { MakeInjectable } from "../DependencyInjection/DependencyInjection";
import { Database } from "./supabase";

export class SupabaseService {
    supabaseInstance: SupabaseClient<Database, "public">
    public get instance() {
        return this.supabaseInstance;
    }

    constructor() {
        const supabaseUrl = 'https://ykmpgqcwhlivtlsbwmfz.supabase.co';
        // Legacy JWT anon key was rejected (401 on every auth call, login and
        // signup alike) — the project has moved to the new publishable/secret
        // key format. Same project, same key infraccoon already uses.
        this.supabaseInstance = createClient<Database>(supabaseUrl, "sb_publishable_syYue1BrmdBh-0xWQzSg1g_PHb3NHOT")
    }
}

MakeInjectable(SupabaseService, []);